import { createFileRoute } from "@tanstack/react-router";
import { ApiAccessPage } from "@/components/settings/api-access-page";

export const Route = createFileRoute("/_dashboard/api-access")({
  component: ApiAccessPage,
});
